import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { formatMessage } from "devextreme/localization";
import { environment } from "../../../environments/environment";

@Component({
  selector: "app-produkt",
  templateUrl: "./produkt.component.html",
  styleUrls: ["./produkt.component.scss"],
})
export class ProduktComponent implements OnInit {
  formatMessage = formatMessage;
  produktId: string;

  returnPath: string = environment.isUsa ? "/product" : "/produkt";

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.produktId = params.get("id") || "";
    });
  }
}
